import { render } from "./PurchaseDealModal.vue?vue&type=template&id=8fa46386&ts=true&lang=pug"
import script from "./PurchaseDealModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseDealModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__